import {
    BaseFeatureArgs,
    FixedFilterGenerator,
} from '@common/types/queryState';

export const composeGenerators = <A extends BaseFeatureArgs>(
    newGenerator: FixedFilterGenerator<A>,
    existingGenerators: FixedFilterGenerator<A>[] | undefined = [],
): FixedFilterGenerator<A>[] => {
    return [newGenerator, ...existingGenerators];
};
